import { useState, useEffect } from "react";
import {
  FormInput,
  FormProvider,
  useAlert,
  useForm,
  useGetError,
  useUpdateOnSubmit,
  FormCheckBox,
  FormSelect,
} from "@hilma/forms";
import { useHasTwoFactorToken, useSendCode } from "@hilma/auth";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";

import { Button, EducationMultipleSelect, LocationAutocomplete } from "../components";
import { signUpRules } from "../constants";

const initialValues = {
  name: "",
  phone: "",
  email: "",
  gender: "",
  // hasExperience: "",
  education: "",
  heAddress: "",
  terms: false,
  lat: null,
  lng: null,
  cityId: "",
};

const SignUp: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [mapsLoading, setMapsLoading] = useState(true);
  
  // Check if Google Maps API is loaded
  useEffect(() => {
    const checkGoogleMapsLoaded = () => {
      if (window.google && window.google.maps) {
        console.log('Google Maps API loaded successfully');
        setMapsLoading(false);
      } else {
        console.log('Google Maps API not loaded yet, retrying...');
        setTimeout(checkGoogleMapsLoaded, 500);
      }
    };
    
    checkGoogleMapsLoaded();
  }, []);
  
  const alert = useAlert();

  const sendCode = useSendCode();
  const classes = useStyles();
  // const hasTwoFactorToken = useHasTwoFactorToken();
  const form = useForm();
  const navigate = useNavigate();
  const getError = useGetError();
  
  // Debug form values changes
  useEffect(() => {
    console.log('Current form values:', form.values);
  }, [form.values]);

  useUpdateOnSubmit(async (values) => {
    try {
      setLoading(true);
      console.log('Form submitted with values:', values);
      
      // Check if we have location data when an address was entered
      if (values.heAddress && (!values.lat || !values.lng)) {
        console.warn('Address entered but location data missing');
        alert("אנא המתן לטעינת נתוני המיקום או בחר כתובת מהרשימה");
        setLoading(false);
        return;
      }
      
      // Create a separate object for standard fields
      const standardFields = {
        username: values.phone,
      };
      
      // Create a separate object for the location data
      const locationData = {
        lat: values.lat ? Number(values.lat) : null,
        lng: values.lng ? Number(values.lng) : null,
        cityId: values.cityId || "",
      };
      
      console.log('Sending data to API:', { ...values, ...standardFields, ...locationData });
      
      // Use type assertion to bypass TypeScript's type checking
      const { success, msg } = await sendCode(
        "/api/candidate/send-code-to-new-candidate",
        // Use type assertion to tell TypeScript to trust us
        { ...values, ...standardFields, ...locationData } as any
      );
      if (!success) setLoading(false);
      if (!success && !msg.data?.message)
        alert("אין אפשרות לשלוח קוד. נא לנסות שוב מאוחר יותר");
      if (!success && msg.data?.message === "user already exists")
        alert("מספר הטלפון כבר קיים במערכת");
      if (success) navigate("/sign-in");
    } catch (error: any) {
      console.error(error);
      setLoading(false);
      alert(getError(error));
    }
  });

  return (
    <>
      {/* <ArrowBack className={classes.button} onClick={() => history.push('./sign-in')} /> */}
      <FormInput id="name" description="שם מלא" />

      <FormInput id="phone" description="טלפון" />
      <FormInput id="email" description="דואר אלקטרוני" />
      <FormSelect
        id="gender"
        description="מין"
        options={[
          { id: 1, value: "זכר" },
          { id: 2, value: "נקבה" },
        ]}
      />
      <LocationAutocomplete
        id="heAddress"
        description="כתובת"
        loading={mapsLoading}
      />
      <div style={{ fontSize: '10px', color: '#999', marginTop: '5px' }}>
        {form.values.lat && form.values.lng ? 
          `מיקום נבחר: ${form.values.lat}, ${form.values.lng}` : 
          'טרם נבחר מיקום'}
      </div>
      {/* <FormSelect
        id="hasExperience"
        // description=" האם יש לך תיק עובד הוראה פעיל במשרד החינוך – תשובה מתוך
        // בחירה כן/לא "
        description="האם יש לך תיק עובד הוראה פעיל במשרד החינוך "
        options={[
          { id: 1, value: "כן" },
          { id: 2, value: "לא" },
        ]}
      /> */}

      <EducationMultipleSelect />
      {/* <RadioGroupInput id='education' description="השכלה" options={candidateEducationsArray} /> */}
      <FormCheckBox
        id="terms"
        description={
          <div>
            קראתי את{" "}
            <a href="/terms-and-conditions" target="_blank">
              תנאי השימוש
            </a>
          </div>
        }
      />

      <Button
        className={classes.okButton}
        onClick={() => form.handleSubmit()}
        loading={loading}
      >
        המשך
      </Button>
      <Link to="/sign-in" className={classes.link}>
        יש לי כבר משתמש
      </Link>
    </>
  );
};

const SignUpComp: React.FC = () => (
  <FormProvider initialValues={initialValues} rules={signUpRules}>
    <SignUp />
  </FormProvider>
);
export default SignUpComp;

const useStyles = makeStyles((theme) => ({
  container: {
    paddingBottom: 20,
    height: "auto",
  },
  link: {
    color: theme.palette.primary.main,
    textAlign: "center",
    width: "fit-content",
    margin: "auto",
    marginTop: "1em",
    fontSize: "1.3rem",
  },
  okButton: {
    marginTop: 20,
  },
}));
